import type { RuleListUsage } from "@src/features/ai/pages/agentic-logic/rules/ruleListRows";

/**
 * How many experiences other than this one a rule serves — the "Used in N
 * other experiences" warning under the rule picker (ENG-7894), so an author
 * knows a change to the rule lands elsewhere too.
 *
 * An experience counts once however many of its groups use the rule, and a
 * store-wide row (no experience) is not one. Null while the usages are
 * unknown, so a read still in flight never reads as "used nowhere".
 */
export const otherExperienceCount = (
  usages: readonly RuleListUsage[] | null,
  currentExperienceId: string | null
): number | null => {
  if (usages === null) {
    return null;
  }
  const others = new Set(
    usages
      .map((usage) => usage.experience?.id)
      .filter(
        (id): id is string => id !== undefined && id !== currentExperienceId
      )
  );
  return others.size;
};
